import { render, staticRenderFns } from "./MoveToExternalDialog.vue?vue&type=template&id=7f3ad1bc&"
import script from "./MoveToExternalDialog.vue?vue&type=script&lang=ts&"
export * from "./MoveToExternalDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports